module.exports = __webpack_public_path__ + "img/2.591b511c.jpg";